module.exports = __webpack_public_path__ + "img/05_no.3fcca0ea.svg";